<template>
    <v-dialog v-model="dialog" max-width="650px">
        <template #activator="{ on, attrs }">
            <v-icon v-bind="attrs" size="32" v-on="on">mdi-information-outline</v-icon>
        </template>
        <v-card>
            <v-card-title class="headline">{{ t('default::dialog.label.information') }}</v-card-title>
            <v-card-text>
                <table>
                    <tbody v-if="!_.isEmpty(data)">
                        <tr v-for="(item, index) in data" :key="index">
                            <td>{{ index }}</td>
                            <td>
                                <b>{{ item }}</b>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small rounded @click="dialog = false">{{ t('default::button.close') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            dialog: false,
        };
    },
};
</script>
